// A read-only quantity (tonnage, litres, units) as a screen, email or printed
// document shows it: comma thousands grouping pinned to en-US, decimals only
// when the figure carries them, up to QUANTITY_DECIMALS.
//
// Replaces bare `toLocaleString()` / `Intl.NumberFormat` on quantities: with no
// options those stop at 3 decimals, so a 320.123412 t tonnage read 320.123
// (card: six-decimals-across-the-chain). Same approach as `formatQty` in
// components/ShipmentOverview/VesselOverviewGrid.js: the text is read as
// written, never through a float, so a long six-decimal figure keeps its last
// digit. A number, or text only parseFloat can read, goes through the number
// -- the same value the call sites' own parseFloat checks compare against.
//   formatQuantityDisplay('320.123412') -> '320.123412'
//   formatQuantityDisplay('5000.0000')  -> '5,000'
//   formatQuantityDisplay(1234567.5)    -> '1,234,567.5'
//   formatQuantityDisplay('')           -> ''
import { formatAmount } from './amountFormat';
import { formatFigure, QUANTITY_DECIMALS } from './precision';

export const formatQuantityDisplay = (raw) => {
  if (raw === null || raw === undefined || raw === '') return '';
  const figure = formatFigure(raw, 0, QUANTITY_DECIMALS)
    || formatFigure(parseFloat(raw), 0, QUANTITY_DECIMALS);
  return formatAmount(figure);
};
